
























































import { Component, Vue } from "vue-property-decorator";
import { LAPORAN_IGD_CARDS } from "@/config/sidebar-menu";
import { userModule } from "@/store/modules/user";

interface LaporanIgdCard {
  route: string;
  title: string;
  subtitle: string;
  desc: string;
  icon: string;
  color: string;
  privilege: { domain: string; action?: string };
}

@Component
export default class LaporanIgdMenuPage extends Vue {
  get visibleCards(): LaporanIgdCard[] {
    return (LAPORAN_IGD_CARDS as LaporanIgdCard[]).filter(
      card =>
        userModule.hasPrivilege(
          card.privilege.domain,
          card.privilege.action || "view"
        )
    );
  }

  goto(card: LaporanIgdCard) {
    this.$router.push({ name: card.route }).catch(() => undefined);
  }
}
